import * as CubeTree from '../../cubeTree/index';
import Utils from '../../utils/util';
import { layerCubeSize, layerCubeSizeContainSpace } from '../size/index';

// 从前往后查找，获取层板下指定宽度区域的cube, cube溢出宽度不能超过自身一半
function getCubeHalfInTargetWidth(cubeIds: CubeId[], width: PhysicsMeasurement): CubeId[] {
    let result: CubeId[] = [];
    let getedWidth: PhysicsMeasurement = 0;

    if (width === 0) {
        return result;
    }

    for(let i = 0; i < cubeIds.length; i++) {
        let cube: CubeId = cubeIds[i];
        if (CubeTree.isBafflePlate(cube)) continue;
        let cubeWidth: PhysicsMeasurement = layerCubeSize(cube).width;
        let halfCubeWidth: PhysicsMeasurement = Utils.math(cubeWidth, 2, '/');

        getedWidth = Utils.math(getedWidth, cubeWidth, '+');

        let overflowWidth: PhysicsMeasurement = Utils.math(getedWidth, width, '-');

        if (overflowWidth <= halfCubeWidth) {
            result.push(cube);
            continue;
        }
        break;
    }

    return result;
}

function getCubeInTargetWidth(cubeIds: CubeId[], width: PhysicsMeasurement): CubeId[] {
    let result: CubeId[] = [];
    let getedWidth: PhysicsMeasurement = 0;

    if (width === 0) {
        return result;
    }

    for(let i = 0; i < cubeIds.length; i++) {
        let cube: CubeId = cubeIds[i];
        if (CubeTree.isBafflePlate(cube)) break;
        let cubeWidth: PhysicsMeasurement = layerCubeSize(cube).width;

        getedWidth = Utils.math(getedWidth, cubeWidth, '+');

        let overflowWidth: PhysicsMeasurement = Utils.math(getedWidth, width, '-');

        if (overflowWidth < cubeWidth) {
            result.push(cube);
            continue;
        }
        break;
    }

    return result;
}

// 从前往后查找，获取层板下指定宽度区域的cube, cube溢出宽度不能超过自身一半
function getCubeHalfInTargetWidthContainSpace(cubeIds: CubeId[], width: PhysicsMeasurement): CubeId[] {
    let result: CubeId[] = [];
    let getedWidth: PhysicsMeasurement = 0;

    if (width === 0) {
        return result;
    }

    for(let i = 0; i < cubeIds.length; i++) {
        let cube: CubeId = cubeIds[i];
        if (CubeTree.isBafflePlate(cube)) continue;
        let cubeWidth: PhysicsMeasurement = layerCubeSizeContainSpace(cube).width;
        let halfCubeWidth: PhysicsMeasurement = Utils.math(cubeWidth, 2, '/');

        getedWidth = Utils.math(getedWidth, cubeWidth, '+');

        let overflowWidth: PhysicsMeasurement = Utils.math(getedWidth, width, '-');

        if (overflowWidth <= halfCubeWidth) {
            result.push(cube);
            continue;
        }
        break;
    }

    return result;
}

// 从后往前查找，获取层板下指定宽度区域的cube, cube溢出宽度不能超过自身一半
function getCubeHalfInTargetWidthEndToFront(cubeIds: CubeId[], width: PhysicsMeasurement): CubeId[] {
    let result: CubeId[] = [];
    let getedWidth: PhysicsMeasurement = 0;

    if (width === 0) {
        return result;
    }

    for(let i = cubeIds.length - 1; i >= 0; i--) {
        let cube: CubeId = cubeIds[i];
        if (CubeTree.isBafflePlate(cube)) continue;
        let cubeWidth: PhysicsMeasurement = layerCubeSize(cube).width;
        let halfCubeWidth: PhysicsMeasurement = Utils.math(cubeWidth, 2, '/');

        getedWidth = Utils.math(getedWidth, cubeWidth, '+');

        let overflowWidth: PhysicsMeasurement = Utils.math(getedWidth, width, '-');

        if (overflowWidth <= halfCubeWidth) {
            result.push(cube);
            continue;
        }
        break;
    }

    return result;
}

export {
    getCubeInTargetWidth,
    getCubeHalfInTargetWidth,
    getCubeHalfInTargetWidthEndToFront,
    getCubeHalfInTargetWidthContainSpace
};
